import { render } from "./PhoneApp.vue?vue&type=template&id=2033612b"
import script from "./PhoneApp.vue?vue&type=script&lang=js"
export * from "./PhoneApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__